var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReception(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#EE7203;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,51.3l18.1-12c0.7-0.4,0.9-1.3,0.4-2c-0.4-0.7-1.3-0.9-2-0.4L27.3,47.3c1.3-18.1,16.7-32.6,35.2-32.6 c15.6,0,29,10,33.7,24.8c0.2,0.7,1.1,1.1,1.8,0.9c0.7-0.2,1.1-1.1,0.9-1.8C94,22.6,79.3,11.9,62.6,11.9 c-19.6,0-35.7,14.7-37.9,33.7l-9.4-14.3c-0.4-0.7-1.3-0.9-2-0.4c-0.7,0.4-0.9,1.3-0.4,2l11.6,17.8l0,0l0.2,0.2c0,0,0.2,0,0.2,0.2 c0,0,0.2,0,0.2,0.2c0,0,0,0,0.2,0h0.2C26,51.6,26.2,51.6,26.7,51.3C26.5,51.3,26.7,51.3,26.7,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.1,66.9l-11.6-17.8l0,0l-0.2-0.2c0,0-0.2,0-0.2-0.2h-0.2c0,0,0,0-0.2,0c0,0,0,0-0.2,0c0,0,0,0-0.2,0 c0,0,0,0-0.2,0h-0.2h-0.2c0,0,0,0-0.2,0l-18.1,12c-0.7,0.4-0.9,1.3-0.4,2c0.4,0.7,1.3,0.9,2,0.4l15.8-10.5 C96.3,71,80.9,85.2,62.4,85.2c-15.6,0-29-10-33.7-24.8c-0.2-0.7-1.1-1.1-1.8-0.9c-0.7,0.2-1.1,1.1-0.9,1.8 c4.9,16.1,19.6,26.8,36.3,26.8c19.6,0,35.7-14.7,37.9-33.7l9.4,14.3c0.2,0.4,0.7,0.7,1.1,0.7c0.2,0,0.4,0,0.9-0.2 C112.5,68.5,112.5,67.6,112.1,66.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReception);
export default __webpack_public_path__ + "static/media/reception.dc7a511b520206f7365a919a1eaa79e7.svg";
export { ForwardRef as ReactComponent };